import React from 'react';

const WorkDetail = () => {
    return (
        <div>
            
        </div>
    );
};

export default WorkDetail;